// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"74":"3bd5e8dc","78":"e4541c3d","79":"c18f62d9","239":"9614b904","313":"c3c2f749","338":"10916076","541":"c66c2c0a","544":"e4e69629","576":"b3043f52","743":"72abaed6","753":"fbe93f98","775":"ac6475f4","899":"5c2b5b7d","982":"dcae6622","990":"358a2b13"}[chunkId] + ".js";
};